<template>
  <!-- <div class="items__wrap"> -->
  <div
    class="dialog-app-panel items__wrap"
    :class="showPanel ? 'dialog-show' : ''"
  >
    <appPanel
      class="app-panel"
      :isExpand="showPanel"
      :title="
        pageStates == 'add'
          ? '新增防火巡查项'
          : pageStates == 'edit'
          ? '编辑防火巡查项'
          : '防火巡查项详情'
      "
      @cancel="handleClosePanel"
    >
      <el-form
        :inline="true"
        :model="form"
        :rules="rules"
        ref="refForm"
        label-width="90px"
        label-suffix=" ："
      >
        <el-col :span="12">
          <el-form-item label="名称" prop="firePatrolName">
            <el-input
              v-if="pageStates != 'view'"
              v-model="form.firePatrolName"
              placeholder="请输入名称"
            ></el-input>
            <span v-else>
              {{ form.firePatrolName }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="form.status" v-if="pageStates != 'view'">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">禁用</el-radio>
            </el-radio-group>
            <span v-else>
              {{ form.status | dic("SENU11102") }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="desc">
            <el-input
              v-if="pageStates != 'view'"
              maxlength="200"
              show-word-limit
              clearable
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              v-model="form.desc"
              placeholder="请输入描述"
            ></el-input>
            <span v-else>
              {{ form.desc }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="巡查项" prop="firePatrolItemList">
            <span
              v-if="pageStates != 'view'"
              type="text"
              style="font-size: 14px; cursor: pointer"
              class="el-icon-circle-plus-outline"
              @click="handleAdd"
            >
              添加</span
            >
          </el-form-item>
        </el-col>
      </el-form>
      <div style="height: calc(100% - 190px)">
        <ioc-table ref="crud" :data="tableData" :option="option">
          <template
            slot="menu"
            slot-scope="scope"
            width="100"
            fixed="right"
            v-if="pageStates != 'view'"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="下移"
              placement="top"
              popper-class="tooltip-draw"
            >
              <span
                v-if="tableData.length > 1"
                class="el-icon-bottom btn"
                @click="moveDown(scope.index)"
              >
              </span>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="上移"
              placement="top"
              popper-class="tooltip-draw"
            >
              <span
                v-if="scope.index != 0"
                class="el-icon-top btn"
                @click="moveUp(scope.index)"
              >
              </span>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
              popper-class="tooltip-draw"
            >
              <span
                class="el-icon-edit-outline btn"
                @click="handleEdit(scope.row, scope.index)"
              ></span>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              popper-class="tooltip-draw"
            >
              <span
                class="el-icon-remove-outline btn"
                @click="handleDel(scope.row, scope.index)"
              ></span>
            </el-tooltip>
          </template>
        </ioc-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel" type="info" :loading="subLoading">
          {{ pageStates == "view" ? "关闭" : "取消" }}
        </el-button>
        <el-button
          v-if="pageStates != 'view'"
          type="primary"
          :loading="subLoading"
          @click="handleSavePanel"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
    <el-dialog
      title="巡检项"
      :visible.sync="dialogVisible"
      append-to-body
      @close-before="handleClose"
      :close-on-click-modal="false"
      width="650px"
    >
      <el-form
        style="height: 190px"
        :inline="true"
        :model="itemForm"
        :rules="itemRules"
        ref="refItemForm"
        label-width="85px"
        label-suffix=" ："
      >
        <el-col :span="24">
          <el-form-item label="名称" prop="firePatrolItemName">
            <el-input
              v-model="itemForm.firePatrolItemName"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位" prop="unit">
            <el-input
              v-model="itemForm.unit"
              placeholder="请输入单位"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类型" prop="type">
            <el-select v-model="itemForm.type" placeholder="请选择">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="itemForm.type == 1 || itemForm.type == 2">
          <el-form-item label="正常值" prop="normalItems">
            <el-input
              v-model="itemForm.normalItems"
              placeholder="请输入正常值"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="itemForm.type == 1 || itemForm.type == 2">
          <el-form-item label="异常值" prop="exceptionItems">
            <el-input
              v-model="itemForm.exceptionItems"
              placeholder="请输入异常值"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="itemForm.type == 3">
          <el-form-item label="上限" prop="upperLimit">
            <el-input
              v-model="itemForm.upperLimit"
              placeholder="请输入上限值"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="itemForm.type == 3">
          <el-form-item label="下限值" prop="lowerLimit">
            <el-input
              v-model="itemForm.lowerLimit"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="itemForm.type == 3">
          <el-form-item label="默认值" prop="defaultValue">
            <el-input
              v-model="itemForm.defaultValue"
              placeholder="请输入默认值"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import { Dic } from "@src/common/utils";
import tableOption from "../config/items";
import appPanel from "@src/components/business/app-panel/index";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      editFormIndex: null,
      showPanel: false,
      pageStates: "add",
      subLoading: false,
      typeOptions: Dic.find("SENU11101"),
      option: tableOption(this),
      dialogVisible: false,
      firePatrolCode: "",
      form: {
        firePatrolName: "",
        status: "",
        desc: "",
        firePatrolItemList: [],
      },
      rules: {
        firePatrolName: [
          {
            required: true,
            message: "请输入名称",
            trigger: ["blur", "change"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["change"],
          },
        ],
        firePatrolItemList: [
          {
            required: true,
            message: "请添加巡检项",
            trigger: ["blur", "change"],
          },
        ],
      },
      itemForm: {
        firePatrolItemName: "",
        unit: "",
        type: "",
        upperLimit: "",
        lowerLimit: "",
        normalItems: "",
        exceptionItems: "",
        defaultValue: "",
      },
      itemRules: {
        firePatrolItemName: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择",
            trigger: ["blur", "change"],
          },
        ],
        upperLimit: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        lowerLimit: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        normalItems: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        exceptionItems: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
        defaultValue: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
      },
      tableData: [],
    };
  },
  methods: {
    handleClosePanel() {
      this.showPanel = false;
      this.$refs.refForm.resetFields();
      this.tableData = [];
      this.firePatrolCode = "";
      this.pageStates = "add";
    },
    handleSavePanel() {
      this.$refs.refForm.validate((res) => {
        if (!res) {
          return;
        }
        let params = {
          firePatrolName: this.form.firePatrolName,
          status: this.form.status,
          desc: this.form.desc,
          firePatrolItemList: this.tableData,
        };
        let url = api.addFirePatrolItems;
        if (this.firePatrolCode) {
          url = api.updateFirePatrolItems;
          params.firePatrolCode = this.firePatrolCode;
        }
        this.subLoading = true;
        console.log(params);
        this.$fetch(url, params).then((res) => {
          this.subLoading = false;
          if (!res.success) {
            this.$message.error(res.msgContent || "操作失败");
            return;
          } else {
            this.handleClosePanel();
            this.$message.success("操作成功");
            this.$emit("handleUpdate");
          }
        });
      });
    },
    handleAdd() {
      this.dialogVisible = true;
      this.editFormIndex = null;
    },
    handleEdit(row, index) {
      this.itemForm = { ...row };
      console.log(this.itemForm);
      this.itemForm.type = Number(row.type);
      this.editFormIndex = index;
      this.dialogVisible = true;
    },
    moveDown(index) {
      let item = this.tableData.splice(index, 1)[0];
      this.tableData.splice(index + 1, 0, item);
    },
    moveUp(index) {
      let item = this.tableData.splice(index, 1)[0];
      this.tableData.splice(index - 1, 0, item);
    },
    handleDel(row, index) {
      this.tableData.splice(index, 1);
      this.form.firePatrolItemList = this.tableData;
      this.$refs.refForm.validateField("firePatrolItemList");
    },
    handleClose() {
      this.$refs.refItemForm.resetFields();
      this.dialogVisible = false;
      this.editFormIndex = null;
    },
    handleSave() {
      this.$refs.refItemForm.validate((res) => {
        if (!res) {
          return;
        }
        if (this.editFormIndex == null) {
          this.tableData.push({
            ...this.itemForm,
          });
        } else {
          let item = JSON.parse(JSON.stringify(this.itemForm));
          this.$set(this.tableData, this.editFormIndex, item);
        }
        this.form.firePatrolItemList = this.tableData;
        this.$refs.refForm.validateField("firePatrolItemList");
        this.handleClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  width: 100%;
  display: flex;
  :deep .el-form-item__content {
    width: calc(100% - 100px);
  }
  .el-input__inner {
    width: 100%;
  }
}
.items {
  &__wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .btn {
      margin: 0 4px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>